import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { deleteShipApi } from "@/API/deleteShipApi";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { ShowNotification } from "@/components/ShowNotification";

export const useDeleteShip = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteShipId, setDeleteShipId] = useState<string | null>(null);
  const [associatedStudies, setAssociatedStudies] = useState<any[]>([]);
  const [isAssociatedStudiesModalOpen, setIsAssociatedStudiesModalOpen] =
    useState(false);

  const { invalidateShips } = useInvalidateQueries();

  const { mutateAsync: deleteShip } = useMutation({
    mutationFn: deleteShipApi,
    onSuccess: (response) => {
      if (response.status === "success") {
        setIsDeleteModalOpen(false);
        setDeleteShipId(null);
        ShowNotification({
          title: "Ship deleted!",
          message: response.message,
          color: "info",
        });
      } else if (response.status === "fail") {
        setIsDeleteModalOpen(false);
        setDeleteShipId(null);
        setAssociatedStudies(response.studies || []);
        setIsAssociatedStudiesModalOpen(true);
      } else {
        ShowNotification({
          title: "Error",
          message: "An unexpected error occurred while deleting the ship.",
          color: "error",
        });
      }
    },
    onError: (error) => {
      console.error("Error deleting ship:", error);
      ShowNotification({
        title: "Error",
        message: "An error occurred while deleting the ship.",
        color: "error",
      });
    },
    onSettled: () => {
      invalidateShips();
    },
  });

  const handleDeleteShip = (shipId: string) => {
    setDeleteShipId(shipId);
    setIsDeleteModalOpen(true);
  };

  return {
    deleteShip,
    handleDeleteShip,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    deleteShipId,
    setDeleteShipId,
    associatedStudies,
    setAssociatedStudies,
    isAssociatedStudiesModalOpen,
    setIsAssociatedStudiesModalOpen,
  };
};
